import { useState, useEffect, useRef } from "react"

export const useElementDimensions = () => {
	const ref = useRef(null)
	const [width, setWidth] = useState(0)
	const [height, setHeight] = useState(0)
	const [top, setTop] = useState(0)
	const [right, setRight] = useState(0)
	const [bottom, setBottom] = useState(0)
	const [left, setLeft] = useState(0)

	useEffect(() => {
		const element = ref.current
		if (!element) return

		const updateDimensions = () => {
			const rect = element.getBoundingClientRect()
			setWidth(rect.width)
			setHeight(rect.height)
			setTop(rect.top)
			setRight(rect.right)
			setBottom(rect.bottom)
			setLeft(rect.left)
		}

		updateDimensions()

		window.addEventListener("resize", updateDimensions)

		const resizeObserver = new ResizeObserver(updateDimensions)
		resizeObserver.observe(element)

		return () => {
			window.removeEventListener("resize", updateDimensions)
			resizeObserver.disconnect()
		}
	}, [])

	return { ref, width, height, top, right, bottom, left }
}
